import { resolveSiteUrl } from "~/utils/resolve-site-url";

type AskAiSummaryProps = {
  url: string;
  className?: string;
};

export type AiSummaryService = {
  name: string;
  base: string;
  icon: string;
};

export const AI_SUMMARY_SERVICES: AiSummaryService[] = [
  {
    name: "ChatGPT",
    base: "https://chatgpt.com/?q=",
    icon: "/images/ai/chatgpt.svg",
  },
  {
    name: "Claude",
    base: "https://claude.ai/new?q=",
    icon: "/images/ai/claude.svg",
  },
  {
    name: "Perplexity",
    base: "https://www.perplexity.ai/search?q=",
    icon: "/images/ai/perplexity.svg",
  },
  {
    name: "Google AI Mode",
    base: "https://www.google.com/search?udm=50&aep=11&q=",
    icon: "/images/ai/google.svg",
  },
];

export function buildAiSummaryPrompt(url: string): string {
  const absoluteUrl = `${resolveSiteUrl()}${url.startsWith("/") ? url : `/${url}`}`;
  return `Give me a summary of this post: ${absoluteUrl}`;
}

export function AskAiSummary({ url, className }: AskAiSummaryProps) {
  const encoded = encodeURIComponent(buildAiSummaryPrompt(url));

  return (
    <div className={`rounded-20 bg-cream py-4 pl-2 pr-4 ${className ?? ""}`}>
      <p className="font-body text-sm font-medium text-charcoal">
        Ask AI to write a summary of this post
      </p>
      <div className="mt-3 flex items-center gap-2">
        {AI_SUMMARY_SERVICES.map((s) => (
          <a
            key={s.name}
            href={`${s.base}${encoded}`}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`Ask ${s.name} to summarize this post`}
            className="flex h-10 w-10 items-center justify-center rounded-md bg-white shadow-card transition hover:shadow-lg"
          >
            <img src={s.icon} alt="" width={24} height={24} className="block h-6 w-6" />
          </a>
        ))}
      </div>
    </div>
  );
}
